/**
 * Simple geocoding lookup for sample data locations.
 * Maps common US cities to approximate lat/lng for map display.
 */
export const CITY_COORDS: Record<string, [number, number]> = {
  "new york": [40.7128, -74.006],
  "chicago": [41.8781, -87.6298],
  "miami": [25.7617, -80.1918],
  "san francisco": [37.7749, -122.4194],
  "houston": [29.7604, -95.3698],
  "los angeles": [34.0522, -118.2437],
  "seattle": [47.6062, -122.3321],
  "boston": [42.3601, -71.0589],
  "phoenix": [33.4484, -112.074],
  "denver": [39.7392, -104.9903],
  "atlanta": [33.749, -84.388],
  "san antonio": [29.4241, -98.4936],
  "san jose": [37.3382, -121.8863],
  "portland": [45.5152, -122.6784],
  "washington": [38.9072, -77.0369],
  "newark": [40.7357, -74.1724],
  "detroit": [42.3314, -83.0458],
  "norfolk": [36.8508, -76.2859],
  "nashville": [36.1627, -86.7816],
  "las vegas": [36.1699, -115.1398],
  "austin": [30.2672, -97.7431],
  "charlotte": [35.2271, -80.8431],
  "remote": [39.8283, -98.5795], // center of US
  "lagos": [6.5244, 3.3792],
  "abuja": [9.0579, 7.4951],
  "london": [51.5074, -0.1278],
  "nairobi": [1.2921, 36.8219],
  "accra": [5.6037, -0.187],
  "johannesburg": [-26.2041, 28.0473],
  "cape town": [-33.9249, 18.4241],
};

/** Deterministic pseudo-random offset so unknown locations never jump between renders. */
function hashOffset(seed: string): [number, number] {
  let h = 2166136261;
  for (let i = 0; i < seed.length; i++) {
    h ^= seed.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  const a = ((h >>> 0) % 1000) / 1000;
  const b = ((h >>> 10) % 1000) / 1000;
  return [(a - 0.5) * 8, (b - 0.5) * 16];
}

export function locationToCoords(location: string): [number, number] {
  const lower = (location || "").toLowerCase().trim();
  if (lower) {
    for (const [city, coords] of Object.entries(CITY_COORDS)) {
      if (lower.includes(city)) return coords;
    }
  }
  // Stable fallback (center of US + deterministic offset) so pins stay put.
  const [dLat, dLng] = hashOffset(lower || "unknown");
  return [39.8 + dLat, -98.5 + dLng];
}
